

import { i18n } from '@/iti-core-vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { EventAddClick } from './iti-data-table-events';
import { ItiIconButton } from '@/iti-core-vuetify';

@Component({
  components: {
    ItiIconButton,
  },
})
export default class ItiDataTable extends Vue {
  @Prop() public title!: string;
  @Prop() public headers!: any[];
  @Prop() public buttons!: any[];
  @Prop() public items!: any[];
  @Prop() public loading!: boolean;
  @Prop({ default: 'Buscar' }) public searchText!: string;
  @Prop({ default: 'No hay resultados para la búsqueda' })
  public noResultsText!: string;
  @Prop({ default: '' }) public color!: string;
  @Prop({ default: false }) public flat!: boolean;
  @Prop({ default: false }) public searchHidden!: boolean;
  @Prop({ default: true }) public showButtonAdd!: boolean;

  public search = '';
  public addHidden = true;

  public get tableFooter(){
    return { disablePagination : false,
      disableItemsPerPage : false,
      'items-per-page-all-text': i18n.tc('all'),
      'items-per-page-text': i18n.tc('rows-per-page'),
    }
  }

  constructor() {
    super();
  }

  public mounted() {
    // En 0,5 segundos mostramos el botón de añadir para que haga una animáción visible
    setTimeout(() => {
      this.addHidden = false;
    }, 500);
  }

  public newItem() {
    this.$emit(EventAddClick);
  }

  public buttonClick(eventName: string, item: any) {
    this.$emit(eventName, item);
  }
}
